(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodCarousel', sodCarousel);

    function sodCarousel($timeout) {
        return {
            restrict: 'E',
            controller: sodCarouselCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                items: '=?',
            },
            templateUrl: 'common/components/sod-carousel',
        };
    }

    function sodCarouselCtrl($timeout,$window) {
        this.$onInit = function() {
            var vm = this;
            vm.loading = true;

            vm.onInit = function () {
                $timeout(function () {
                    vm.loading = false;
                    $window.dispatchEvent(new Event("resize"));
                }, 1000);
            }
        }
    }
})();